import {
  Box,
  Button,
  capitalize,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useCallback, useState } from "react";
import {
  DatePicker,
  downloadExcelFile,
  formatDateToYYYYMMDD,
  useAuth,
} from "../../sdk";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import CloseIcon from "@mui/icons-material/Close";

export const DownloadOverridePriceDialog = ({
  open,
  handleClose,
  setOpen,
  setnetworkMsg,
}) => {
  const [fileFromDate, setFileFromDate] = useState(new Date());
  const [fileToDate, setFileToDate] = useState(new Date());
  const { authFetch } = useAuth();
  const { hotelId } = useParams();

  const downloadOverridePriceFile = useCallback(async () => {
    try {
      const startDate = formatDateToYYYYMMDD(fileFromDate);
      const endDate = formatDateToYYYYMMDD(fileToDate);

      const { get } = await authFetch({
        path: `/hotel/${hotelId}/download-override-logs?start=${startDate}&end=${endDate}`,
      });

      const { data, error, response } = await get();
      if (response?.ok) {
        downloadExcelFile(data);
        handleClose();
        setnetworkMsg("File Downloaded Successfully");
        setOpen(true);
      } else {
        console.log(error);
        setnetworkMsg("Something Went Wrong!");
        setOpen(true);
      }
    } catch (error) {
      console.error(error);
      setnetworkMsg("Something Went Wrong!");
      setOpen(true);
    }
  }, [
    authFetch,
    fileFromDate,
    fileToDate,
    handleClose,
    hotelId,
    setOpen,
    setnetworkMsg,
  ]);

  return (
    <StyledChannelDialog open={open} onClose={handleClose}>
      <DialogTitle className="content">
        <Typography className="dialog-heading">
          Download Override Price Details
        </Typography>
      </DialogTitle>

      <DialogContent className="content">
        <Typography variant="body1">
          Select Date Range for override details
        </Typography>

        <Stack direction="row" gap="40px">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack className="date-selecter-stack">
              <Typography className="range-label">From</Typography>
              <StyledCalenderWrapper>
                <DatePicker
                  inputFormat={"dd/MM/yyyy"}
                  style={{ zIndex: 98 }}
                  value={fileFromDate}
                  onChange={(date) => {
                    setFileFromDate(date);
                    if (fileToDate < date) {
                      setFileToDate(date);
                    }
                  }}
                />
              </StyledCalenderWrapper>
            </Stack>

            <Stack className="date-selecter-stack">
              <Typography className="range-label">To</Typography>
              <StyledCalenderWrapper>
                <DatePicker
                  inputFormat={"dd/MM/yyyy"}
                  style={{ zIndex: 98 }}
                  value={fileToDate}
                  onChange={setFileToDate}
                  minDate={fileFromDate}
                />
              </StyledCalenderWrapper>
            </Stack>
          </LocalizationProvider>
        </Stack>

        <Button
          className="download-button"
          variant="contained"
          onClick={() => downloadOverridePriceFile()}
        >
          Download
        </Button>
      </DialogContent>

      <CloseIcon className="closeButton" onClick={handleClose} />
    </StyledChannelDialog>
  );
};

const StyledChannelDialog = styled(Dialog)(() => ({
  ".MuiPaper-root": { overflow: "visible", padding: "10px" },
  ".closeButton": {
    position: "absolute",
    right: "10px",
    top: "10px",
    cursor: "pointer",
  },
  ".content": {
    padding: "10px 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "visible",
    gap: "30px",
  },
  ".dialog-heading": {
    fontSize: "18px",
    color: "#163A90",
    fontWeight: 600,
  },
  ".date-selecter-stack": {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
  },
  ".range-label": {
    fontSize: "16px",
    fontWeight: 600,
    color: "#163A90",
  },
  ".download-button": {
    borderRadius: "10px",
    textTransform: capitalize,
  },
  ".custom-input": {
    textAlign: "left",
    marginBottom: "2px",
    fontSize: "14px",
    borderRadius: "10px",
    color: "#000000",
    outline: "none",
    height: "30px",
    border: "none",
    font: "bold 16px / 20px Roboto",
    cursor: "pointer",
    width: "140px",
    paddingLeft: "14px",
  },
}));

const StyledCalenderWrapper = styled(Box)((theme) => ({
  borderRadius: "8px",
  boxShadow: "0px 4px 4px rgba(48, 111, 188, 0.2)",
  "&:hover>*": {
    color: "#ffffff",
    ">input": {
      backgroundColor: "#306fbc",
      color: "#ffffff !important",
    },
  },
}));
